export default __webpack_public_path__ + "static/media/close.68f5890b.svg";